export { EconomicActivity } from './economic-activity';
export { KnowYourCostumer } from './know-your-costumer';
export { PoliticalExposedPerson } from './political-exposed-person';
export { FinancialInformationResume } from './resume';
